export default {
  data() {
    return {
      tempKey: "",
      tempConfId: "",
    };
  },
  methods: {
    /**
     * 关闭时有内容询问，无内容关闭
     */
    beforeClose() {
      if (this.showNew && !this.isWrite()) {
        this.confirmClose();
      } else {
        this.close();
      }
    },
    confirmClose() {
      this.$confirm(this.$t('answer.检测到答题内容有改动'), this.$t('answer.提示'), {
        confirmButtonText: this.$t('answer.保存'),
        cancelButtonText: this.$t('answer.不保存'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: "confirm_save",
      })
        .then(() => {
          this.$refs.showadd.submeAnswer();
          this.close();
        })
        .catch(() => {
          this.$refs.showadd.resumeDefault();
          this.close();
        });
    },
    isWrite() {
      let flag = true;
      const showadd = this.$refs.showadd;
      const answerTitle = this.$refs.showadd.$refs.answerList.answerTitle
      const answerList = showadd.answer;
      if (
        answerTitle !== "" ||
        answerList.options.length > 2 ||
        answerList.options[0].item !== "" ||
        answerList.options[1].item !== ""
      ) {
        flag = false;
      }
      return flag;
    },
    confirmClick(webcastId,confWebcastId) {
      this.$confirm(this.$t('answer.检测到答题内容有改动'), this.$t('answer.提示'), {
        confirmButtonText: this.$t('answer.保存'),
        cancelButtonText: this.$t('answer.不保存'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: "confirm_save",
      })
        .then(() => {
          this.tempKey = webcastId;
          this.tempConfId = confWebcastId;
          this.$refs.showadd.submeAnswer();
        })
        .catch((err) => {
          console.log(err);
          this.toPaper(webcastId,confWebcastId);
          this.resumeDefault && this.resumeDefault()
        });
    },
    toPaper(webcastId,confWebcastId) {
      this.showNew = false;
      this.showInfo = true;
      this.actionTabsKey = webcastId;
      this.answerId = webcastId;
      this.confPaperId = confWebcastId;
    },
  },
};
